import { Array, Static, Object, Optional, Number, String } from '@sinclair/typebox';

import { UnionEnum } from '../../../utils/unionEnum';
import { BonusProgram } from '../../sas-domain';

import { TravelPassApiError } from './error';

export const TravelPassTraveler = Object({
  id: String(),
  firstName: String(),
  lastName: String(),
  phone: Optional(String()),
  gender: Optional(String()),
  email: Optional(String()),
  ebNumber: Optional(String()),
  middleName: Optional(String()),
  dateOfBirth: Optional(String()),
  bonusProgram: Optional(BonusProgram),
  type: Optional(String()),
});
export type TravelPassTraveler = Static<typeof TravelPassTraveler>;

export const TravelPassTravelersQuery = Object({
  filter: Optional(String()),
  pageNumber: Optional(Number()),
  pageSize: Optional(Number()),
});
export type TravelPassTravelersQuery = Static<typeof TravelPassTravelersQuery>;

export const TravelPassTravelersError = TravelPassApiError(UnionEnum(['missing-travelers-query-params']));
export type TravelPassTravelersError = Static<typeof TravelPassTravelersError>;

export const TravelPassTravelersResponse = Object({
  travelers: Array(TravelPassTraveler),
  currentPage: Number(),
  totalPages: Number(),
  totalItems: Number(),
  pageSize: Number(),
});
export type TravelPassTravelersResponse = Static<typeof TravelPassTravelersResponse>;
